import { AutogenModelEdiControlShared, AutogenRowEdiControlShared } from "./autogen/AutogenModelEdiControlShared";

export class ModelEdiControlShared extends AutogenModelEdiControlShared<RowEdiControlShared> {
	constructor() {
		super(RowEdiControlShared);
	}
}

export class RowEdiControlShared extends AutogenRowEdiControlShared {
}